import React from "react";

const Heading = ({ className, level = 2, style, children }) => {
  const Tag = `h${level}`;

  return (
    <div
      style={style}
      className={`${className} text-xl/10 font-montserrat font-semibold tracking-wider break-words animate-fade-in-left hyphens-auto text-black/80`}
    >
      <Tag>{children}</Tag>
    </div>
  );
};

export default Heading;
